/**
 * @generated SignedSource<<959f17cd24fc7e10409aded50c76621c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RetellingStatus = "FAILED" | "PENDING" | "READY" | "%future added value";
export type RetellingFeedbackQuery$variables = {
  id: string;
};
export type RetellingFeedbackQuery$data = {
  readonly node: {
    readonly better?: string | null | undefined;
    readonly book?: {
      readonly id: string;
    } | null | undefined;
    readonly corrections?: ReadonlyArray<{
      readonly explanation: string;
      readonly id: string;
      readonly learnerForm: string;
      readonly spanEnd: number | null | undefined;
      readonly spanStart: number | null | undefined;
      readonly targetForm: string;
    }>;
    readonly firstPage?: number;
    readonly id?: string;
    readonly lastPage?: number;
    readonly status?: RetellingStatus;
    readonly strength?: string | null | undefined;
    readonly text?: string;
  } | null | undefined;
};
export type RetellingFeedbackQuery = {
  response: RetellingFeedbackQuery$data;
  variables: RetellingFeedbackQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstPage",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastPage",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "WritingCorrection",
  "kind": "LinkedField",
  "name": "corrections",
  "plural": true,
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "learnerForm",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "targetForm",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "explanation",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "spanStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "spanEnd",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "better",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "strength",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "StoryBook",
  "kind": "LinkedField",
  "name": "book",
  "plural": false,
  "selections": [
    (v2/*:: as any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RetellingFeedbackQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/),
              (v9/*:: as any*/),
              (v10/*:: as any*/)
            ],
            "type": "Retelling",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "RetellingFeedbackQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*:: as any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/),
              (v9/*:: as any*/),
              (v10/*:: as any*/)
            ],
            "type": "Retelling",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f75d27006bf8c94c28bd6f0f9ad2c884",
    "id": null,
    "metadata": {},
    "name": "RetellingFeedbackQuery",
    "operationKind": "query",
    "text": "query RetellingFeedbackQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on Retelling {\n      id\n      status\n      text\n      firstPage\n      lastPage\n      corrections {\n        id\n        learnerForm\n        targetForm\n        explanation\n        spanStart\n        spanEnd\n      }\n      better\n      strength\n      book {\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f1f43187a4c9fce4b06c125702cb3718";

export default node;
